import { object, string, boolean } from 'yup';
import { split, includes } from 'lodash';

const multiIPValidator = value => {
    if (value) {
        const ips = split(value, ',');
        const ipv4Validator = new RegExp(/^(?:(?:^|\.)(?:2(?:5[0-5]|[0-4]\d)|1?\d?\d)){4}$/);

        // eslint-disable-next-line max-len
        const ipv6Validator = new RegExp(/^(([\dA-Fa-f]{1,4}:){7}[\dA-Fa-f]{1,4}|([\dA-Fa-f]{1,4}:){1,7}:|([\dA-Fa-f]{1,4}:){1,6}:[\dA-Fa-f]{1,4}|([\dA-Fa-f]{1,4}:){1,5}(:[\dA-Fa-f]{1,4}){1,2}|([\dA-Fa-f]{1,4}:){1,4}(:[\dA-Fa-f]{1,4}){1,3}|([\dA-Fa-f]{1,4}:){1,3}(:[\dA-Fa-f]{1,4}){1,4}|([\dA-Fa-f]{1,4}:){1,2}(:[\dA-Fa-f]{1,4}){1,5}|[\dA-Fa-f]{1,4}:((:[\dA-Fa-f]{1,4}){1,6})|:((:[\dA-Fa-f]{1,4}){1,7}|:)|fe80:(:[\dA-Fa-f]{0,4}){0,4}%[\dA-Za-z]+|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}\d){0,1}\d)\.){3}(25[0-5]|(2[0-4]|1{0,1}\d){0,1}\d)|([\dA-Fa-f]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}\d){0,1}\d)\.){3}(25[0-5]|(2[0-4]|1{0,1}\d){0,1}\d))$/);

        if (!includes(ips, '')) {
            let validIP = true;

            for (const ip of ips) {
                const validIPv4 = ipv4Validator.test(ip);
                const validIPv6 = ipv6Validator.test(ip);

                if (!validIPv4 && !validIPv6) {
                    validIP = false;
                }
            }

            return validIP;
        }

        return false;
    }

    return false;
};

const ipValidator = () => string()
    .required('REQUIRED')

    // eslint-disable-next-line max-len
    .matches(/^(?:(?:^|\.)(?:2(?:5[0-5]|[0-4]\d)|1?\d?\d)){4}$|^(([\dA-Fa-f]{1,4}:){7}[\dA-Fa-f]{1,4}|([\dA-Fa-f]{1,4}:){1,7}:|([\dA-Fa-f]{1,4}:){1,6}:[\dA-Fa-f]{1,4}|([\dA-Fa-f]{1,4}:){1,5}(:[\dA-Fa-f]{1,4}){1,2}|([\dA-Fa-f]{1,4}:){1,4}(:[\dA-Fa-f]{1,4}){1,3}|([\dA-Fa-f]{1,4}:){1,3}(:[\dA-Fa-f]{1,4}){1,4}|([\dA-Fa-f]{1,4}:){1,2}(:[\dA-Fa-f]{1,4}){1,5}|[\dA-Fa-f]{1,4}:((:[\dA-Fa-f]{1,4}){1,6})|:((:[\dA-Fa-f]{1,4}){1,7}|:)|fe80:(:[\dA-Fa-f]{0,4}){0,4}%[\dA-Za-z]+|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}\d){0,1}\d)\.){3}(25[0-5]|(2[0-4]|1{0,1}\d){0,1}\d)|([\dA-Fa-f]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}\d){0,1}\d)\.){3}(25[0-5]|(2[0-4]|1{0,1}\d){0,1}\d))$/, 'INVALID_IP');

export default object().shape({
    Method:
        string()
            .required('REQUIRED'),
    DNSServer:
        string()
            .test({
                name: 'DNSValidator',
                exclusive: true,
                message: 'INVALID_IP',
                test: value => multiIPValidator(value)
            }),
    LAN: object().shape({
        Method:
            string()
                .required('REQUIRED'),
        IPAddress:
            string()
                .when('Method', {
                    is: 'Static',
                    then: ipValidator()
                }),
        Netmask:
            string()
                .when('Method', {
                    is: 'Static',
                    then: ipValidator()
                }),
        Gateway:
            string()
                .when('Method', {
                    is: 'Static',
                    then: ipValidator()
                })
    }),
    WAN: object().shape({
        Method:
            string()
                .required('REQUIRED'),
        IPAddress:
            string()
                .when('Method', {
                    is: 'Static',
                    then: ipValidator()
                }),
        Netmask:
            string()
                .when('Method', {
                    is: 'Static',
                    then: ipValidator()
                }),
        Gateway:
            string()
                .when('Method', {
                    is: 'Static',
                    then: ipValidator()
                })
    }),
    DHCP: object().shape({
        DHCPServer:
            boolean(),
        IPFrom:
            string()
                .when('DHCPServer', {
                    is: true,
                    then: ipValidator()
                }),
        IPTo:
            string()
                .when('DHCPServer', {
                    is: true,
                    then: ipValidator()
                }),
        Netmask:
            string()
                .when('DHCPServer', {
                    is: true,
                    then: ipValidator()
                }),
        Gateway:
            string()
                .when('DHCPServer', {
                    is: true,
                    then: ipValidator()
                }),
        DNSServer:
            string()
                .when('DHCPServer', {
                    is: true,
                    then:
                        string()
                            .test({
                                name: 'DHCPDNSValidator',
                                exclusive: true,
                                message: 'INVALID_IP',
                                test: value => multiIPValidator(value)
                            })
                }),
        TFTP:
            string()
                .when('DHCPServer', {
                    is: true,
                    then: ipValidator()
                })
    })
});
